import { render, staticRenderFns } from "./block-countdown.vue?vue&type=template&id=15cda138&scoped=true"
import script from "./block-countdown.vue?vue&type=script&lang=js"
export * from "./block-countdown.vue?vue&type=script&lang=js"
import style0 from "./block-countdown.vue?vue&type=style&index=0&id=15cda138&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cda138",
  null
  
)

export default component.exports